import {t} from './i18n.js?v=2';
import { resolveVariant, validQuantity } from './tbt-logic.js';

function initialize(scope = document) {
  scope.querySelectorAll('[data-gallery]:not([data-ready])').forEach(gallery => {
    const images = [...gallery.querySelectorAll('.gallery-image')];
    const choices = [...gallery.querySelectorAll('[data-gallery-target]')];
    gallery.showImage = id => {
      if (!images.some(image => image.id === id)) return;
      images.forEach(image => image.hidden = image.id !== id);
      choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.galleryTarget === id)));
    };
    choices.forEach(choice => choice.addEventListener('click', () => gallery.showImage(choice.dataset.galleryTarget)));
    if (images.length) gallery.showImage(images[0].id);
    gallery.dataset.ready = 'true';
  });
  scope.querySelectorAll('[data-card-color]:not([data-ready])').forEach(choice => {
    choice.dataset.ready = 'true';
    choice.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const card = choice.closest('.product-card');
      card.querySelectorAll('[data-card-link]').forEach(link => link.href = choice.href);
      card.querySelectorAll('[data-card-color]').forEach(link => link.removeAttribute('aria-current'));
      choice.setAttribute('aria-current', 'true');
      card.querySelector('[data-color-label]').textContent = choice.dataset.colorName;
      const image = card.querySelector('.product-media img');
      if (image && choice.dataset.image) {
        image.removeAttribute('srcset'); image.src = choice.dataset.image;
        image.alt = card.querySelector('h3').textContent + ' — ' + choice.dataset.colorName;
      }
    });
  });
  scope.querySelectorAll('.menu-toggle:not([data-ready])').forEach(button => {
    button.dataset.ready = 'true';
    const nav = document.getElementById(button.getAttribute('aria-controls'));
    if (!nav) return;
    const close = () => { nav.hidden = true; button.setAttribute('aria-expanded', 'false'); };
    button.addEventListener('click', () => { nav.hidden = !nav.hidden; button.setAttribute('aria-expanded', String(!nav.hidden)); });
    nav.addEventListener('click', e => { if (e.target.closest('a')) close(); });
    nav.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); button.focus(); } });
    button.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  });
  scope.querySelectorAll('.product-form:not([data-ready])').forEach(form => {
    const data = form.querySelector('[data-variant-data]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.dataset.json); } catch { return; }
    const selects = [...form.querySelectorAll('[data-option-index]')];
    const master = form.querySelector('[data-master-variant]');
    const button = form.querySelector('[data-add-button]');
    const status = form.querySelector('[data-variant-status]');
    const price = form.closest('.product-details').querySelector('[data-product-price]');
    const quantity = form.querySelector('[name="quantity"]');
    const purchasing = button.dataset.purchasing === 'true';
    const update = (navigate = false) => {
      const variant = selects.length ? resolveVariant(variants, selects.map(s => s.value)) : variants.find(v => String(v.id) === master.value);
      master.value = variant ? String(variant.id) : '';
      button.disabled = !purchasing || !variant?.available || !validQuantity(quantity.value);
      button.textContent = !purchasing ? t("Orders opening soon") : !variant ? t("Unavailable") : !variant.available ? t("Sold out") : t("Add to bag");
      status.textContent = !variant ? t("This color and size combination is unavailable.") : !variant.available ? t("This option is currently sold out.") : !validQuantity(quantity.value) ? t("Choose a whole quantity from 1 to 99.") : '';
      price.textContent = variant ? variant.price : t("Unavailable");
      if (navigate && variant) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
        const image = document.getElementById('Image-' + variant.imageId);
        if (image) image.closest('[data-gallery]')?.showImage?.(image.id);
      }
    };
    selects.forEach(s => s.addEventListener('change', () => update(true)));
    master.addEventListener('change', () => update(true));
    quantity.addEventListener('input', () => update(false));
    form.addEventListener('submit', e => { update(false); if (button.disabled) { e.preventDefault(); status.textContent ||= t("Ordering is not yet available."); } });
    form.dataset.ready = 'true'; form.classList.add('enhanced'); update(true);
  });
}
initialize();
document.addEventListener('shopify:section:load', e => initialize(e.target));
